import OverviewModule from '../../store/overview/overview';
import Feature from 'Services/Feature';

var OverviewMixin = {
    data() {
        return {
            name: '',
            dataoverview: {},
            overviewhash: '',
            mappingName: '',
            default: OverviewModule,
            overviewClass: this.$route.meta.overviewClass,
            loading: true,
            navMap: [],
            mainNav: [],
            moreNav: [],
            urlParams: new URLSearchParams(window.location.search),
            contextId: false,
        };
    },

    computed: {
        tabSelected() {
            return this.$store.getters.tabSelected;
        },
    },

    methods: {
        initStore(response) {
            this.setContextId();
            return new Promise((resolve, reject) => {
                this.dataoverview = response.dataoverview;
                this.name = response.name;
                this.mappingName = this.overviewClass.mappingName;

                this.overviewhash = this.name;
                this.registerStore();
                if (this.$store.state.staffs.staffs.length === 0) {
                    this.$store.dispatch('staffs/fetchStaffs');
                }
                resolve();
            });
        },
        setDataoverview() {
            this.dataoverview.dataMap = this.overviewClass.getData();
            this.dataoverview.routes = this.overviewClass.getRoutes();
            this.dataoverview.availableStatCards = this.overviewClass.getAvailableStatCards();
            this.dataoverview.databots = this.overviewClass.getDatabots();
            this.dataoverview.agendaViewConfig = this.overviewClass.getAgendaViewConfig();
        },
        registerStore() {
            const store = this.$store;

            if (!(store && store.state && store.state[this.overviewhash])) {
                if (this.module) {
                    store.registerModule(this.overviewhash, this.module);
                } else {
                    store.registerModule(this.overviewhash, this.default);
                }
            }
        },
        dispatchData() {
            this.$store.dispatch('storeData', this.dataoverview).then(() => {
                this.$store.dispatch('buildFavorites');
            });
        },
        buildNav(navMap) {
            const nav = navMap.map((sectionNav) => {
                // sectionNav equal to Informations and Plugin levels
                const section = {
                    ...sectionNav,
                    items: [],
                };

                sectionNav.items.forEach((mainNav) => {
                    // mainNav equal to nav inside each sections, e.g Estimate/Invoice

                    // Must be Feature enabled
                    if (
                        (mainNav.feature && !Feature.isEnabled(mainNav.feature)) ||
                        !this.isAllowed(mainNav.permission)
                    ) {
                        return;
                    }

                    if (mainNav.group) {
                        if (!section.items.some((group) => group.id === mainNav.group.id)) {
                            section.items.push({ ...mainNav.group, subNav: [] });
                        }

                        // Inject mainNav to group as Subnav, e.g Estimate/Invoice in Documents group
                        section.items
                            .find((item) => item.id === mainNav.group.id)
                            .subNav.push(mainNav);
                    } else {
                        section.items.push(mainNav);
                    }
                });

                return section;
            });
            return nav;
        },
        isDifferentOverview(newRoute, oldRoute) {
            return JSON.stringify(newRoute.params) !== JSON.stringify(oldRoute.params);
        },
        currentRoutedTabConfig() {
            return this.overviewClass
                .getNav()
                .map((section) => section.items)
                .flat()
                .find((item) => item.id === _.last(this.$route.name.split('.')));
        },
        isAllowed(permission) {
            return _.isNil(permission) || this.dataoverview.permissions[permission];
        },
        setContextId() {
            if (this.urlParams.has('contextId')) {
                this.contextId = this.urlParams.get('contextId');
            }
        },
    },
    watch: {
        $route(newRoute, oldRoute) {
            if (this.isDifferentOverview(newRoute, oldRoute)) {
                this.init(this.$route.params.id);
            }
            this.$store.dispatch(
                'updateSelectedTab',
                this.currentRoutedTabConfig() ? this.currentRoutedTabConfig().id : 'informations',
            );
        },
    },
    beforeRouteEnter: (to, from, next) => {
        if (
            to.name === 'third.overview.financialactivity' &&
            !to.meta.overviewClass.checkUrlByNavMapping('financialactivity')
        ) {
            next({ name: 'third.overview', params: to.params });
        }
        if (
            to.name === 'third.overview.statistics' &&
            !to.meta.overviewClass.checkUrlByNavMapping('statistics')
        ) {
            next({ name: 'third.overview', params: to.params });
        }
        next();
    },
};

export default OverviewMixin;
